import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('userData');

    // If no token or no user data, redirect to login
    if (!token || token === 'null' || !userData || userData === 'null') {
        return <Navigate to="/login" replace />;
    }

    try {
        const parsed = JSON.parse(userData);
        if (!parsed || !parsed.msisdn) {
            return <Navigate to="/login" replace />;
        }
    } catch {
        return <Navigate to="/login" replace />;
    }

    return children;
};

export default ProtectedRoute;
